module.exports = "<div class=\"container\">\r\n<h2>\r\n Il n'a pas de page à cette adresse\r\n</h2>\r\n  <mat-grid-list cols=\"1\" rowHeight=\"130px\">\r\n    <mat-grid-tile colspan=\"1\" rowspan=\"1\">\r\n      <img src=\"assets/unHappy.png\">\r\n    </mat-grid-tile>\r\n  </mat-grid-list>\r\n\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/neron/Documents/coo/coo/coo-V3/src/app/page-not-found/page-not-found.component.html
// module id = ../../../../../src/app/page-not-found/page-not-found.component.html
// module chunks = main